<app-status-bar></app-status-bar>
<div class="wrapper w-100 justify-content-center event-sale-wrapper">
    <div class="sale-layout" [class.cart-collapsed]="cartCollapsed">
        <div class="col-events">
            <app-events-resume></app-events-resume>
        </div>
        <div class="col-map">
            <app-seat-map></app-seat-map>
        </div>
        <div class="col-cart" style="margin-top: 80px;">
            <!-- Botón saliendo del borde izquierdo del carrito -->
            <button class="cart-toggle-btn" (click)="toggleCart()" [title]="cartCollapsed ? 'Mostrar carrito' : 'Ocultar carrito'">
                <span class="cart-icon-wrap">
                    <fa-icon [icon]="reservationId ? faBookmark : faCart"></fa-icon>
                    <span class="cart-toggle-badge" *ngIf="reservationId ? totalReservationQuantity > 0 : totalCartQuantity > 0">{{ reservationId ? totalReservationQuantity : totalCartQuantity }}</span>
                </span>
                <fa-icon class="cart-toggle-chevron" [icon]="cartCollapsed ? faChevronLeft : faChevronRight"></fa-icon>
            </button>
            <div class="col-cart-inner">
                <app-reservation-resume *ngIf="reservationId" [reservationId]="reservationId"></app-reservation-resume>
                <app-products-resume *ngIf="!reservationId"></app-products-resume>
            </div>
        </div>
    </div>
</div>
